module.exports = __webpack_public_path__ + "img/code-analysis.2484abc8.webp";